// Container/DamageType API
import {
    RequestConfig, SelectorConfig,
} from 'app/types/request.types'

type DamageTypeRequests = {
    domainName: string,
    filterRequest: ({
        params: any,
    }) => RequestConfig,
    create: () => RequestConfig,
    get: ({
        id: number,
    }) => RequestConfig,
    update: ({
        id: number,
    }) => RequestConfig,
    modifications: ({
        id: number,
    }) => RequestConfig,
    archive: ({
        id: number,
    }) => RequestConfig,
    restore: ({
        id: number,
    }) => RequestConfig,
    selector: SelectorConfig<{ name: string, id: number }[]>,
}

const damageTypeRequests: DamageTypeRequests = {
    domainName: 'DamageType',
    filterRequest: ({
        params,
    }) => {
        return {
            method: 'POST',
            url: 'damagetype/filter-request/all',
            ...params,
        }
    },
    create: () => {
        return {
            url: 'damagetype',
            method: 'POST',
        }
    },
    get: ({
        id,
    }) => {
        return {
            url: `damagetype/${id}`,
            method: 'GET',
        }
    },
    update: ({
        id,
    }) => {
        return {
            url: `damagetype/${id}`,
            method: 'PUT',
        }
    },
    modifications: ({
        id,
    }) => {
        return {
            url: `damagetype/${id}/modifications`,
            method: 'GET',
        }
    },
    archive: ({
        id,
    }) => {
        return {
            url: `damagetype/${id}/archive`,
            method: 'PATCH',
        }
    },
    restore: ({
        id,
    }) => {
        return {
            url: `damagetype/${id}/restore`,
            method: 'PATCH',
        }
    },
    selector: {
        url: 'damagetype/filter-request/selector',
        convertion: (damageTypes) => {
            return damageTypes.map(({
                name, id,
            }) => {
                return {
                    label: name,
                    value: id,
                    id,
                }
            })
        },
    },
}

export default damageTypeRequests
